import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function PushPinIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon
      viewBox="0 0 23 23"
      htmlColor={Color.Gray}
      {...props}
      style={{ scale: "1.4", paddingTop: "2px", ...props.style }}
    >
      <path d="M13.7571 12.6006L14.2955 14.2917L13.881 15.1278L11.2607 13.3659L9.74104 16.4315L9.10081 16.5583L8.87504 15.8492L10.3947 12.7836L7.77447 11.0217L8.18893 10.1857L9.71565 9.8831L11.7083 5.86354L11.1309 5.47532L11.5454 4.63927L16.7415 8.13319L16.327 8.96924L15.7497 8.58103L13.7571 12.6006Z" />
    </MuiSvgIcon>
  );
}
export default PushPinIcon;
